import React, { useCallback, useMemo, useContext } from "react";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setDuration as updateDuration } from "../redux/userSlice";
import { useNavigate } from "react-router-dom";
import { MinorUserContext } from "../context/UserNameProvider";
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

import Question from "../components/Question";
import MoveButton from "../components/MoveButton";

export default function Duration() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { isMinor, firstName } = useContext(MinorUserContext);

  const durations = useMemo(() => [
    "More than 1 year",
    "3 months to 1 year",
    "2 weeks to 3 months",
    "Less than 2 weeks",
  ], []);

  const handleDurationSelect = useCallback((duration) => {
    dispatch(updateDuration(duration));
    setPageAndDeferNavigate(dispatch, '/sex-at-birth', navigate);
  }, [dispatch, navigate]);

  const handleBack = () => {
    if (user?.tried.includes("Tried prescription(s)")) {
      // accutane
      if (user.treatmentContinuation?.interestedInAccutane === "Y" && (user.address?.state === "CT" || user.address?.state === "MA")) {
        setPageAndDeferNavigate(dispatch, '/patient-history-lifestyle', navigate);
      } else {
        setPageAndDeferNavigate(dispatch, '/prescriptions', navigate);
      }
    } else {
      setPageAndDeferNavigate(dispatch, '/tried-before', navigate);
    }
  };

  return (
    <Question
      onBack={handleBack}
      title={`How long ${isMinor
        ? `has ${firstName}`
        : 'have you'
        } experienced ${user.concern === "Other / unsure"
          ? "your dermatology issue"
          : (user.concern || "this").toLowerCase()
        }?`}
      input={
        <Grid container spacing={2} >
          {durations.map((dur) => (
            <Grid item xs={12} sm={6} key={dur} >
              <MoveButton
                sx={{ width: "100%", maxWidth: "500px" }}
                onClick={() => handleDurationSelect(dur)}
                title={dur}
                selected={user.duration === dur}
              />
            </Grid>
          ))}
        </Grid>
      }
    />
  );
}
